// extracted by mini-css-extract-plugin
module.exports = {"notFoundMessage":"NotFoundMessage_notFoundMessage__DSrvo","icon":"NotFoundMessage_icon__2Sz8H","fadeIn":"NotFoundMessage_fadeIn__2QmJ7","fadeOut":"NotFoundMessage_fadeOut__Ed6PV"};